import { Reveal } from "@/components/Reveal";
import { Search, User, Users, GraduationCap, HeartHandshake, ClipboardList, ArrowUpRight } from "lucide-react";

const OFFERINGS = [
  {
    icon: Search,
    testid: "service-card-screening",
    title: "Screening Programme",
    text: "Structured speech and language screenings for whole classes or referred students — up to 10 children per visit.",
  },
  {
    icon: User,
    testid: "service-card-individual",
    title: "Individual Therapy",
    text: "One-to-one sessions with an individualised plan, delivered in a quiet corner of your school.",
  },
  {
    icon: Users,
    testid: "service-card-group",
    title: "Group Therapy",
    text: "Small-group sessions that build communication, confidence, and peer interaction together.",
  },
  {
    icon: GraduationCap,
    testid: "service-card-teacher-training",
    title: "Teacher Training",
    text: "Practical workshops so your teachers can spot red flags early and support communication in every lesson.",
  },
  {
    icon: HeartHandshake,
    testid: "service-card-parent-counselling",
    title: "Parent Counselling",
    text: "Guided conversations and home strategies so progress continues beyond the school day.",
  },
  {
    icon: ClipboardList,
    testid: "service-card-progress-reports",
    title: "Progress Reports",
    text: "Clear written reports every month, ready for parent meetings and management reviews.",
  },
];

export const Services = ({ onBook }) => (
  <section id="services" className="border-y border-pine-900/10 bg-sand py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">For schools</p>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="max-w-xl font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
            What we offer schools.
          </h2>
          <button
            data-testid="services-book-link"
            onClick={onBook}
            className="group flex items-center gap-1.5 text-sm font-semibold text-clay"
          >
            Book a free consult
            <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {OFFERINGS.map((o, i) => (
          <Reveal key={o.testid} delay={(i % 3) * 0.08}>
            <div
              data-testid={o.testid}
              className="group flex h-full flex-col rounded-3xl border border-pine-900/10 bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-honey hover:shadow-xl"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-pine-900 text-honey transition-colors duration-300 group-hover:bg-pine-800">
                <o.icon size={18} />
              </span>
              <h3 className="mt-6 font-serif text-xl font-semibold text-pine-950">{o.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-600">{o.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-10 text-center font-serif text-lg italic text-pine-900/80 sm:text-xl" data-testid="services-inschool-note">
          All services delivered in-school — shaped around your timetable.
        </p>
      </Reveal>
    </div>
  </section>
);
